import React, {useRef, useEffect} from 'react';
import {Animated, Easing} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import styled from 'styled-components/native';
import theme from '../../../../global/styles/legacy/theme';
import {RFValue} from 'react-native-responsive-fontsize';

interface AnimatedGradientBorderProps {
  children: React.ReactNode;
  show: boolean;
}

const BorderWrapper = styled.View`
  align-items: center;
  justify-content: center;
`;

const InnerContainer = styled.View<{show: boolean}>`
  margin: ${({show}) => (show ? '2px' : '0px')};
`;

const borderWrapperSize = RFValue(80);

const AnimatedGradientBorder: React.FC<AnimatedGradientBorderProps> = ({
  children,
  show,
}) => {
  const rotateAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    if (!show) return;
    Animated.loop(
      Animated.timing(rotateAnim, {
        toValue: 1,
        duration: 3000,
        easing: Easing.linear,
        useNativeDriver: true,
      }),
    ).start();
  }, [rotateAnim, show]);

  const rotation = rotateAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg'],
  });

  return (
    <BorderWrapper
      style={{
        overflow: 'hidden',
        borderRadius: 4,
        height: RFValue(58),
      }}>
      {show && (
        <Animated.View
          style={{
            position: 'absolute',
            width: borderWrapperSize,
            height: borderWrapperSize,
            transform: [{rotate: rotation}],
          }}>
          <LinearGradient
            colors={[
              theme.colors.gold,
              theme.colors.purple_2_shadow_white,
              theme.colors.yellow,
            ]} // Escolha as cores desejadas
            style={{width: borderWrapperSize, height: borderWrapperSize}}
          />
        </Animated.View>
      )}
      <InnerContainer show={show}>{children}</InnerContainer>
    </BorderWrapper>
  );
};

export default AnimatedGradientBorder;
